<input type="file" #fileUpload (change)="fileChangeHandler($event)" [multiple]="!singleFileAllowed">

@if (!singleFileAllowed || singleFileAllowed && fileList.length < 1) {
  <div class="drag-container" [class.invalid]="validate && fileList.length == 0" (click)="fileUpload.click()"
    (dragover)="dragOverHandler($event)"
    (drop)="dropHandler($event)" (dragenter)="dragEnterHandler($event)" (dragleave)="dragLeaveHandler($event)"
    >
    <div class="content">
      <div class="icon" (click)="openCamera($event)">
        <mat-icon svgIcon="camera-light"></mat-icon>
      </div>
      <div class="separator">
      </div>
      <div class="text">
        {{(isFileDragOver ? 'drag-n-drop.drop-here' : 'drag-n-drop.drag-n-drop') | translate}}
      </div>
    </div>
  </div>
}

@if (fileList.length > 0) {
  <div class="file-list">
    @for (file of fileList; track file) {
      <div class="file">
        <div class="file-icon"></div>
        <div class="file-name">{{file.name}}</div>
        <div class="file-flex-placeholder"></div>
        <div class="file-delete" (click)="deleteFile(file)"></div>
      </div>
    }
  </div>
}
